export const state = {
    loading: 0
}

// getters
export const getters = {
    loading: state => state.loading
}

// mutations
export const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    }
}

// actions
export const actions = {
    addLoading({commit, state}) {
        commit('setLoading', state.loading + 1)
    },

    subLoading({commit, state}) {
        commit('setLoading', state.loading - 1)
    }
}
